<template>
    <div>
        <el-form :model="servcWorkVoucher" class="demo-ruleForm">
            <div class="content-caption dashed">
                <span>零售商信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>零售商</label>
                    </div>
                    <div class="form-value">
                        <span>{{servcWorkVoucher.buyerName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务单元</label>
                    </div>
                    <div class="form-value">
                        <span>{{servcWorkVoucher.buyerBizUnitName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{servcWorkVoucher.buyerShopName}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>卖方信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>卖方商户</label>
                    </div>
                    <div class="form-value">
                        <span>{{servcWorkVoucher.sellerName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>卖方机构</label>
                    </div>
                    <div class="form-value">
                        <span>{{servcWorkVoucher.sellerComName}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>服务信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>是否卖方安装</label>
                    </div>
                    <div class="form-value">
                        <el-radio-group v-model="servcWorkVoucher.sellerSetupFlag" @change="setupFlagChange">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="form-group center" v-if="!servcWorkVoucher.sellerSetupFlag">
                    <div class="form-label required">
                        <label class="required">服务商</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="servicerName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="servcWorkVoucher.servicerName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectServicer"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>紧急状态</label>
                    </div>
                    <div class="form-value">
                        <el-select placeholder="请选择" v-model="servcWorkVoucher.emgLevel">
                            <el-option v-for="emgLevel in emgLevelList" :key="emgLevel.value" :label="emgLevel.text" :value="emgLevel.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">服务</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x bottom-line" :disabled="true" v-model="servcWorkVoucher.servcTitle"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectServc"></i>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>安装明细</span>
                <a class="swb-btn-link" @click="selectDevc">选择</a>
            </div>
            <div class="table-layout">
                <el-table :data="devcSetupItemList" border style="width: 100%">
                    <el-table-column prop="devcXN" label="设备编号" width="220" align="left"></el-table-column>
                    <el-table-column prop="shopDeviceSvcSubNo.vendorUkno" label="商品标识码" align="left" width="220"></el-table-column>
                    <el-table-column prop="shopDeviceSvcSubNo.sellerName" label="卖家名称" align="left" width="220"></el-table-column>
                    <el-table-column prop="extraInfo" label="其他信息" align="left"></el-table-column>
                    <el-table-column prop="asmblFlag" label="含组装商品" width="150" align="center">
                        <template slot-scope="rows">
                            <span>{{rows.row.asmblFlag ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="asmblDone" label="是否组装完毕" width="150" align="center">
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblFlag">{{rows.row.asmblDone ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="asmblWhileSetup" label="安装时完成组装" width="150" align="center">
                        <template slot-scope="rows">
                            <span>{{rows.row.asmblWhileSetup ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" label="操作">
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeItem(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content-caption dashed">
                <span>其他信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center" v-if="showBasicClaim">
                    <div class="form-label">
                        <label>价格质量要求</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-select placeholder="请选择" class="fl" v-model="basicClaimIndex" @change="selectBasicClaim">
                            <el-option v-for="(basicClaim, index) in servcBasicClaimList" :key="basicClaim.id" :label="basicClaim.goodsModel" :value="index"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">上门费</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.toDoorFee"></el-input>
                        <span>元</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">服务费</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.generallFee"></el-input>
                        <span>元</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求响应时长</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.yqRspTimeMi"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求到达时长</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.yqArriveTimeMi" @change="yqArriveTimeMiChange"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求完成时长</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.yqRepairedTimeMi"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求回询时限</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.reqTelCallTimeMi"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">预约时间</label>
                    </div>
                    <div class="form-value">
                        <el-date-picker class="width-2x" :clearable=false v-model="servcWorkVoucher.planTime" type="datetime" placeholder="选择预约时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>图片</label>
                    </div>
                    <div class="form-value">
                        <div class="clearfix" style="margin-top: 6px;">
                            <swb-file-upload class="fl inline-block" fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                            <span class="fl ml10">(提供上传截图,1 ~ 5张)</span>
                        </div>
                        <ul class="file-area clearfix" v-if="servcWorkImgList != null && servcWorkImgList.length > 0">
                            <!--<li class="file-content clearfix" v-for="(servcWorkImg, index) in servcWorkImgList">-->
                            <template v-for="(servcWorkImg, index) in servcWorkImgList">
                                <swb-file-item :trackKey="index" :fileName="servcWorkImg.fileName" :fileUuid="servcWorkImg.fileUuid" :fileBrowseUrl="servcWorkImg.fileBrowseUrl" :fileDownloadUrl="servcWorkImg.fileDownLoadUrl" :fileMd5="servcWorkImg.fileMd5" :deletable="true" :onDelete="removeFileUpload"></swb-file-item>
                            </template>
                            <!--</li>-->
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">安装说明</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input type="textarea" v-model="servcWorkVoucher.troubleDesc"></el-input>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'
    import userApi from '../../api/user'
    import goodsDelivApi from '../../api/goodsDeliv'
    import servcClaimApi from '../../api/servcClaim'

    import { openServicerSelectComnDlg } from './showDetailDlg'
    import { openServcDlg } from '../servc/selectDlg'
    import { showAssetSelectDlg } from '../retailer/selectDlg';
    import { showDevcSelectDlg } from '../devc/selectDlg'

    export default{
        name: 'swb-servc-work-voucher-setup-save',
        desc: '安装工单',
        props: {
            recvId: {
                // 收货单id
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                servcWorkVoucher: {
                    servcType: 2,
                    sellerSetupFlag: true,
                    yqRspTimeMi: 30,
                    yqArriveTimeMi: 60,
                    yqRepairedTimeMi: 120,
                    reqTelCallTimeMi: 0,
                    toDoorFee: null,
                    generallFee: null,
                    troubleDesc: '',
                    emgLevel: 0,
                    planTime: null
                },
                servcWorkImgList: [],
                devcSetupItemList: [],
                goodsRecvVoucher: {},
                emgLevelList: getEnumList("emgLevel", 'value2text'),
                servcBasicClaimList: [],
                showBasicClaim: false,
                basicClaimIndex: 0
            }
        },
        created: function () {
            let dateNow = new Date();
            let planTime = dateNow.setTime(dateNow.getTime() + this.servcWorkVoucher.yqArriveTimeMi * 60 * 1000);
            this.servcWorkVoucher.planTime = planTime;
            this.getGoodsRecvVoucherInfo();
        },
        methods: {
            getGoodsRecvVoucherInfo(){
                let self = this;
                let postData = {};
                postData.id = this.recvId;
                let loading = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherInfo(postData, function (result) {
                    loading.close();
                    if(result.type === "info") {
                        self.goodsRecvVoucher = result.data;
                        self.handleVoucherInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleVoucherInfo(){
                let goodsRecvVoucher = this.goodsRecvVoucher;
                let servcWorkVoucher = this.servcWorkVoucher;
                servcWorkVoucher.buyerId = goodsRecvVoucher.buyerId;
                servcWorkVoucher.buyerName = goodsRecvVoucher.buyerName;
                servcWorkVoucher.buyerShopId = goodsRecvVoucher.buyerShopId;
                servcWorkVoucher.buyerShopName = goodsRecvVoucher.buyerShopName;
                servcWorkVoucher.buyerBizUnitId = goodsRecvVoucher.buyerBizUnitId;
                servcWorkVoucher.buyerBizUnitName = goodsRecvVoucher.buyerBizUnitName;
                servcWorkVoucher.goodsSellerId = goodsRecvVoucher.sellerId;
                servcWorkVoucher.goodsSellerType = goodsRecvVoucher.sellerType;
                //
                servcWorkVoucher.sellerName = goodsRecvVoucher.sellerName;
                servcWorkVoucher.sellerComName = goodsRecvVoucher.sellerComName;
                this.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
            },
            removeItem(index){
                this.devcSetupItemList.removeAt(index);
                this.devcSetupItemList = Utils.merge([], this.devcSetupItemList);
            },
            selectServicer(){
                let self = this;
                let servcWorkVoucher = this.servcWorkVoucher;
                let params = {
                    showBizRel: true,
                };
                openServicerSelectComnDlg(params, function (servicer) {
                    servcWorkVoucher.servicerId = servicer.servicerId;
                    servcWorkVoucher.servicerName = servicer.servicerName;
                    // 清除服务信息
                    servcWorkVoucher.ssuId = null;
                    servcWorkVoucher.servcId = null;
                    servcWorkVoucher.servcTitle = null;
                    servcWorkVoucher.servcCatId = null;
                    //
                    self.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                    self.renderServcInfo(null, null, null, null, null, null, true);
                });
            },
            selectServc: function () {
                let self = this;
                let servcWorkVoucher = self.servcWorkVoucher;
                let merchantId = servcWorkVoucher.goodsSellerId;
                let merchantType = servcWorkVoucher.goodsSellerType;
                if(!servcWorkVoucher.sellerSetupFlag) {
                    if(Utils.isNoB(servcWorkVoucher.servicerId)) {
                        this.$message.warning('请选择服务商');
                        return;
                    }
                    merchantId = servcWorkVoucher.servicerId;
                    merchantType = 4;
                }
                let params = {
                    merchantId: merchantId,
                    merchantType: merchantType,
                    type: 2,
                    checkedIds: [servcWorkVoucher.ssuId],
                    checkBox: false
                };
                openServcDlg(params, function (result) {
                    servcWorkVoucher.ssuId = result.ssuId;
                    servcWorkVoucher.servcId = result.servcId;
                    servcWorkVoucher.servcTitle = result.title;
                    servcWorkVoucher.servcCatId = result.catId;
                    //
                    self.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                    self.renderServcInfo(result.rspTimeMi, result.arriveTimeMi, result.repairedTimeMi, result.telCallTimeMi, result.toDoorFee, result.generallFee, true);
                });
            },
            renderServcInfo(rspTimeMi, arriveTimeMi, repairedTimeMi, telCallTimeMi, toDoorFee, generallFee, queryFlag){
                let self = this;
                let servcWorkVoucher = self.servcWorkVoucher;
                this.getBasicClaimByAppliedShop(queryFlag, function (servcBasicClaimList) {
                    if(servcBasicClaimList != null && servcBasicClaimList.length > 0) {
                        if(servcBasicClaimList.length > 1 || self.basicClaimIndex == null) {
                            self.showBasicClaim = true;
                        }
                        if(self.basicClaimIndex != null) {
                            let basicClaim = servcBasicClaimList[self.basicClaimIndex];
                            rspTimeMi = basicClaim.rspTimeMi;
                            arriveTimeMi = basicClaim.arriveTimeMi;
                            repairedTimeMi = basicClaim.repairedTimeMi;
                            telCallTimeMi = basicClaim.telCallTimeMi;
                            toDoorFee = basicClaim.toDoorFee;
                            generallFee = basicClaim.generallFee;
                        }
                    } else {
                        self.showBasicClaim = false;
                    }
                    servcWorkVoucher.yqRspTimeMi = rspTimeMi;
                    servcWorkVoucher.yqArriveTimeMi = arriveTimeMi;
                    servcWorkVoucher.yqRepairedTimeMi = repairedTimeMi;
                    servcWorkVoucher.reqTelCallTimeMi = telCallTimeMi;
                    servcWorkVoucher.toDoorFee = toDoorFee;
                    servcWorkVoucher.generallFee = generallFee;
                    //
                    let yqArriveTimeMi = servcWorkVoucher.yqArriveTimeMi;
                    if(!Utils.isNoB(yqArriveTimeMi) && Utils.isNaturalStr(yqArriveTimeMi, true)) {
                        let dateNow = new Date();
                        let planTime = dateNow.setTime(dateNow.getTime() + yqArriveTimeMi * 60 * 1000);
                        servcWorkVoucher.planTime = planTime;
                    }
                    self.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                });
            },
            getBasicClaimByAppliedShop(queryFlag, callback){
                let self = this;
                if(queryFlag) {
                    let postData = {};
                    postData.servcTypeId = 2;
                    postData.appliedShopId = this.servcWorkVoucher.buyerShopId;
                    postData.servcCatId = this.servcWorkVoucher.servcCatId;
                    let loading = MsgBox.loading();
                    servcClaimApi.getServcBasicClaimByAppliedShop(postData, function (result) {
                        loading.close();
                        if(result.type === "info") {
                            self.basicClaimIndex = 0;
                            self.servcBasicClaimList = result.data;
                            callback(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    callback(this.servcBasicClaimList);
                }
            },
            selectBasicClaim(){
                this.renderServcInfo(null, null, null, null, null, null, false);
            },
            yqArriveTimeMiChange(){
                let servcWorkVoucher = this.servcWorkVoucher;
                let yqArriveTimeMi = servcWorkVoucher.yqArriveTimeMi;
                if(!Utils.isNoB(yqArriveTimeMi) && Utils.isNaturalStr(yqArriveTimeMi, true)) {
                    let dateNow = new Date();
                    let planTime = dateNow.setTime(dateNow.getTime() + yqArriveTimeMi * 60 * 1000);
                    servcWorkVoucher.planTime = planTime;
                    this.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                }
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                let servcWorkImgList = this.servcWorkImgList || [];
                if(servcWorkImgList.length > 5) {
                    MsgBox.warning("最多上传5张图片!");
                    return false;
                }
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                let servcWorkImgList = self.servcWorkImgList || [];
                if(result.type === 'info') {
                    let files = result.data.files || [];
                    if(files.length + servcWorkImgList.length > 5) {
                        MsgBox.warning("最多可上传5张图片！");
                        return false;
                    }
                    for(let i = 0; i < files.length; i++) {
                        let file = files[i];
                        let servcWorkImg = {};
                        servcWorkImg.fileName = file.fileName;
                        servcWorkImg.fileUuid = file.fileUuid;
                        servcWorkImg.fileExtName = file.fileExtName;
                        servcWorkImg.fileBrowseUrl = file.fileBrowseUrl;
                        servcWorkImg.fileDownLoadUrl = file.fileDownloadUrl;
                        servcWorkImg.fileMd5 = file.fileMd5;
                        servcWorkImg.type = getEnumInfoWith("servcWorkFileType", "name", "Repair").value;
                        servcWorkImgList.push(servcWorkImg);
                        self.servcWorkImgList = Utils.merge([], servcWorkImgList);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            },
            removeFileUpload: function (index) {
                this.servcWorkImgList.removeAt(index.trackKey);
                return false;
            },
            getDlgResult(){
                let servcWorkVoucher = this.servcWorkVoucher;
                let devcSetupItemList = this.devcSetupItemList;
                // 检查必选项
                if(!servcWorkVoucher.sellerSetupFlag) {
                    if(Utils.isNoB(servcWorkVoucher.servicerId)) {
                        this.$message.warning('请选择服务商');
                        return null;
                    }
                }
                if(Utils.isNoB(servcWorkVoucher.ssuId)) {
                    this.$message.warning('请选择服务');
                    return null;
                }
                if(devcSetupItemList.length == 0) {
                    this.$message.warning('请选择安装明细！');
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.toDoorFee) || !Utils.isMoneyStr(servcWorkVoucher.toDoorFee)) {
                    this.$message.warning("请正确填写上门费！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.generallFee) || !Utils.isMoneyStr(servcWorkVoucher.generallFee)) {
                    this.$message.warning("请正确填写服务费！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.yqRspTimeMi) || !Utils.isNaturalStr(servcWorkVoucher.yqRspTimeMi)) {
                    this.$message.warning("请正确填写要求响应时长！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.yqArriveTimeMi) || !Utils.isNaturalStr(servcWorkVoucher.yqArriveTimeMi)) {
                    this.$message.warning("请正确填写要求到达时长！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.yqRepairedTimeMi) || !Utils.isNaturalStr(servcWorkVoucher.yqRepairedTimeMi)) {
                    this.$message.warning("请正确填写要求完成时长！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.reqTelCallTimeMi) || !Utils.isNaturalStr(servcWorkVoucher.reqTelCallTimeMi)) {
                    this.$message.warning("请正确填写要求回询时限！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.planTime)) {
                    this.$message.warning("预约时间不能为空！");
                    return null;
                } else {
                    servcWorkVoucher.planTime = new Date(servcWorkVoucher.planTime).format('yyyy-MM-dd HH:mm');
                }
                let servcWorkImgList = this.servcWorkImgList || [];
                if(servcWorkImgList.length <= 0) {
                    //this.$message.warning("请至少上传一张图片！");
                    //return null;
                } else if(servcWorkImgList.length > 5) {
                    this.$message.warning("最多可上传5张图片！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.troubleDesc)) {
                    this.$message.warning("安装说明不可为空！");
                    return null;
                }
                // 处理安装项
                let devcSetupInfo = {};
                devcSetupInfo.content = servcWorkVoucher.troubleDesc;
                devcSetupInfo.itemCount = devcSetupItemList.length;
                devcSetupInfo.devcCount = devcSetupItemList.length;
                devcSetupInfo.devcSetupItemList = devcSetupItemList;
                //
                servcWorkVoucher.devcSetupInfo = devcSetupInfo;
                servcWorkVoucher.servcWorkImgFileList = servcWorkImgList;
                if(this.servcBasicClaimList != null && this.servcBasicClaimList.length > 0 && this.basicClaimIndex != null && this.basicClaimIndex >= 0) {
                    servcWorkVoucher.refBasicClaimId = this.servcBasicClaimList[this.basicClaimIndex].id;
                }
                // 卖方安装且是供应商
                if(servcWorkVoucher.sellerSetupFlag && servcWorkVoucher.goodsSellerType == 2) {
                    let servcReqVoucher = this.handleServcReqVoucher(servcWorkVoucher);
                    return servcReqVoucher;
                } else {
                    return servcWorkVoucher;
                }
            },
            handleServcReqVoucher(servcWorkVoucher){
                let servcReqVoucher = {};
                servcReqVoucher.buyerId = servcWorkVoucher.buyerId;
                servcReqVoucher.buyerShopId = servcWorkVoucher.buyerShopId;
                servcReqVoucher.emgLevel = servcWorkVoucher.emgLevel;
                //
                servcReqVoucher.servcType = 2;
                servcReqVoucher.ssuId = servcWorkVoucher.ssuId;
                servcReqVoucher.servcId = servcWorkVoucher.servcId;
                servcReqVoucher.title = servcWorkVoucher.servcTitle;
                //
                servcReqVoucher.yqRspTimeMi = servcWorkVoucher.yqRspTimeMi;
                servcReqVoucher.yqArriveTimeMi = servcWorkVoucher.yqArriveTimeMi;
                servcReqVoucher.yqRepairedTimeMi = servcWorkVoucher.yqRepairedTimeMi;
                servcReqVoucher.reqTelCallTimeMi = servcWorkVoucher.reqTelCallTimeMi;
                servcReqVoucher.toDoorFee = servcWorkVoucher.toDoorFee;
                servcReqVoucher.generallFee = servcWorkVoucher.generallFee;
                //
                servcReqVoucher.srcMerchantId = servcWorkVoucher.goodsSellerId;
                servcReqVoucher.srcMerchantType = servcWorkVoucher.goodsSellerType;
                servcReqVoucher.srcMerchantName = servcWorkVoucher.sellerName;
                //
                servcReqVoucher.devcSetupInfo = servcWorkVoucher.devcSetupInfo;
                servcReqVoucher.servcWorkImgFileList = servcWorkVoucher.servcWorkImgFileList;
                servcReqVoucher.refBasicClaimId = servcWorkVoucher.refBasicClaimId;
                //
                return servcReqVoucher;
            },
            setupFlagChange(){
                let servcWorkVoucher = this.servcWorkVoucher;
                // 清除服务信息
                servcWorkVoucher.ssuId = null;
                servcWorkVoucher.servcId = null;
                servcWorkVoucher.servcTitle = null;
                servcWorkVoucher.servcCatId = null;
                //
                this.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                this.renderServcInfo(null, null, null, null, null, null, true);
            },
            selectDevc(){
                let self = this;
                let goodsRecvVoucher = this.goodsRecvVoucher;
                let servcWorkVoucher = this.servcWorkVoucher;
                //
                let devcSetupItemList = this.devcSetupItemList;
                let devcIds = devcSetupItemList.pluck('devcId');
                let filter = {
                    retailerComId: servcWorkVoucher.buyerShopId,
                    recvVoucherId: goodsRecvVoucher.id,
                    setupFlag: true,
                    setupDone: false,
                    queryIncludeNotWarehouse: true,
                    selectAll: false
                };
                let params = {
                    filter: filter,
                    // devcBizClolumType: getEnumInfoWith("devcBizClolumType", "name", "BaoSunDlg").name,   // 调拨选择
                    initSelectIds: devcIds,
                };
                showDevcSelectDlg(params, function (deviceItemList) {
                    let singleDeviceList = Utils.merge([], deviceItemList);
                    if(singleDeviceList != null && singleDeviceList.length > 0) {
                        singleDeviceList.forEach(function (item) {
                            if(devcIds.indexOf(item.id) == -1) {
                                let setupItem = {
                                    retailerId: servcWorkVoucher.buyerId,
                                    shopId: servcWorkVoucher.buyerShopId,
                                    shopName: servcWorkVoucher.buyerShopName,
                                    devcXN: item.tmpNo,
                                    quantity: 1,
                                    extraInfo: item.name + '-' + item.catName + '-' + item.brandName + '-' + item.modelSpec,
                                    devcId: item.id,
                                    devcDefId: item.devcDefId,
                                    asmblFlag: item.asmblFlag,
                                    asmblDone: item.asmblDone,
                                    asmblWhileSetup: item.asmblWhileSetup,
                                    price: item.price,
                                    shopDeviceSvcSubNo: item
                                };
                                if(!setupItem.asmblFlag || setupItem.asmblDone) {
                                    setupItem.asmblFinished = true;
                                } else {
                                    // 需组装未组装完毕时
                                    setupItem.asmblFinished = false;
                                }
                                devcSetupItemList.push(setupItem);
                            }
                        });
                    }
                    self.devcSetupItemList = devcSetupItemList;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherSetupSave.vue